import { React, useState } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import StyledPopover from "../../StyledPopover/StyledPopover";
import UserAutocomplete from "../../Inputs/UserAutocomplete/UserAutocomplete";

export default function SidebarUserSelect({ activeUser, viewingUser, setViewingUser }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const pid = open ? "sidebar-user-select-popover" : undefined;
  const [userName, setUserName] = useState(activeUser?.userName);
  
  const handleUserUpdate = (user) => {
    if (user) {
      setViewingUser(user.userIdMcld);
      setUserName(user.userName);
      setAnchorEl(null);
    }
  };

  return (
    <Box sx={{ padding: "18px 0 10px 16px", display: "flex", alignItems: "center" }}>
      <Typography varient="subhead2" color="black_solid.50" sx={{ marginRight: "10px" }}>
        Viewing
      </Typography>
      <Box 
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{ display: "flex", alignItems: "center", "&:hover": {cursor: "pointer"} }}
      >
        <Typography 
          varient="subhead2" 
          color="black_solid.30" 
        >
          {userName}
        </Typography>
        <KeyboardArrowDownIcon 
          sx={{ color: "black_solid.50", fontSize: "20px" }}
        />
      </Box>
      <StyledPopover
        id={pid}
        open={open}
        anchorEl={anchorEl}
        title="Switch View"
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Box>
          <Typography variant="h4" color="primary.60" sx={{ marginBottom: "20px" }}>
            {`You are viewing ${viewingUser}'s sidebar`}
          </Typography>
          <UserAutocomplete 
            title="Select a Rep to view their sidebar"
            titleSize="12px"
            updateSelectedUser={handleUserUpdate}
            size="small"
            enableUserRegions
            placeholder="Search by Name or Region"
          />
        </Box>  
      </StyledPopover>
    </Box>
  );
}

SidebarUserSelect.propTypes = {
  activeUser: PropTypes.object,
  viewingUser: PropTypes.string,
  setViewingUser: PropTypes.func.isRequired
};